/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ai_Agent_Development_Architect_Detail9Inputs */

const en_svc_ai_agent_development_architect_detail9 = /** @type {(inputs: Svc_Ai_Agent_Development_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Design the loop, tool access, memory layer, and stop conditions.`)
};

const ar_svc_ai_agent_development_architect_detail9 = /** @type {(inputs: Svc_Ai_Agent_Development_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`صمم دورة الوكيل ووصول الأدوات وطبقة الذاكرة وشروط التوقف.`)
};

const bn_svc_ai_agent_development_architect_detail9 = /** @type {(inputs: Svc_Ai_Agent_Development_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`লুপ, টুল অ্যাক্সেস, মেমোরি লেয়ার ও স্টপ কন্ডিশন ডিজাইন করুন।`)
};

const de_svc_ai_agent_development_architect_detail9 = /** @type {(inputs: Svc_Ai_Agent_Development_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entwerfen Sie die Schleife, den Werkzeugzugriff, die Speicherebene und die Stoppbedingungen.`)
};

const es_svc_ai_agent_development_architect_detail9 = /** @type {(inputs: Svc_Ai_Agent_Development_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diseñar el bucle, el acceso a la herramienta, la capa de memoria y las condiciones de parada.`)
};

const fr_svc_ai_agent_development_architect_detail9 = /** @type {(inputs: Svc_Ai_Agent_Development_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Concevez la boucle, l'accès aux outils, la couche mémoire et les conditions d'arrêt.`)
};

const pt_svc_ai_agent_development_architect_detail9 = /** @type {(inputs: Svc_Ai_Agent_Development_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projete o loop, o acesso à ferramenta, a camada de memória e as condições de parada.`)
};

const zh_svc_ai_agent_development_architect_detail9 = /** @type {(inputs: Svc_Ai_Agent_Development_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`设计循环、工具接入、记忆层和停止条件。`)
};

const tr_svc_ai_agent_development_architect_detail9 = /** @type {(inputs: Svc_Ai_Agent_Development_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Döngüyü, araç erişimini, bellek katmanını ve durdurma koşullarını tasarlayın.`)
};

const ru_svc_ai_agent_development_architect_detail9 = /** @type {(inputs: Svc_Ai_Agent_Development_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Спроектируйте цикл, доступ к инструментам, уровень памяти и условия остановки.`)
};

const pl_svc_ai_agent_development_architect_detail9 = /** @type {(inputs: Svc_Ai_Agent_Development_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zaprojektuj pętlę, dostęp do narzędzi, warstwę pamięci i warunki zatrzymania.`)
};

/**
* | output |
* | --- |
* | "Design the loop, tool access, memory layer, and stop conditions." |
*
* @param {Svc_Ai_Agent_Development_Architect_Detail9Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ai_agent_development_architect_detail9 = /** @type {((inputs?: Svc_Ai_Agent_Development_Architect_Detail9Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ai_Agent_Development_Architect_Detail9Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ai_agent_development_architect_detail9(inputs)
	if (locale === "bn") return bn_svc_ai_agent_development_architect_detail9(inputs)
	if (locale === "de") return de_svc_ai_agent_development_architect_detail9(inputs)
	if (locale === "es") return es_svc_ai_agent_development_architect_detail9(inputs)
	if (locale === "fr") return fr_svc_ai_agent_development_architect_detail9(inputs)
	if (locale === "pt") return pt_svc_ai_agent_development_architect_detail9(inputs)
	if (locale === "zh") return zh_svc_ai_agent_development_architect_detail9(inputs)
	if (locale === "tr") return tr_svc_ai_agent_development_architect_detail9(inputs)
	if (locale === "ru") return ru_svc_ai_agent_development_architect_detail9(inputs)
	if (locale === "pl") return pl_svc_ai_agent_development_architect_detail9(inputs)
	return en_svc_ai_agent_development_architect_detail9(inputs)
});
export { svc_ai_agent_development_architect_detail9 as "svc_ai-agent-development_ARCHITECT_detail" }